export const GET_ALL_TYPES = 'GET_ALL_TYPES';


